const GLOBAL = {
  autoplay: true,
  rewind: true,
  pagination: false,
  type: 'loop',
  perMove: 1,
  i18n: {
    prev: 'Poprzedni slajd',
    next: 'Następny slajd',
    first: 'Idź do pierwszego slajdu',
    last: 'Idź do ostatniego slajdu',
    slideX: 'Idź do slajdu numer %s',
    pageX: 'Idź do strony numer %s',
    play: 'Włącz autoodtwarzanie',
    pause: 'Zatrzymaj autoodtwarzanie',
  },
};

export default {
  default: GLOBAL,
  defaultWithPagination: {
    ...GLOBAL,
    pagination: true,
    breakpoints: {
      767: {
        pagination: false,
      },
    },
  },
  productCards: {
    ...GLOBAL,
    gap: 10,
    perPage: 4,
    breakpoints: {
      1199: {
        perPage: 3,
      },
      991: {
        perPage: 2,
      },
      539: {
        perPage: 1,
      },
    },
  },
  waterDistributors: {
    ...GLOBAL,
    arrows: true,
    perPage: 3,
    autoHeight: true,
    breakpoints: {
      539: {
        perPage: 1,
      },
    },
  },
  thumbs: {
    ...GLOBAL,
    isNavigation: true,
    arrows: true,
    perPage: 5,
    height: 80,
    breakpoints: {
      768: {
        perPage: 3,
      },
    },
    perMove: 1,
    gap: 20,
    autoplay: false,
  },
  thumbsContent: {
    ...GLOBAL,
    arrows: false,
    autoplay: false,
  },
  features: {
    ...GLOBAL,
    perPage: 3,
    gap: 50,
    breakpoints: {
      1023: {
        perPage: 2,
      },
      575: {
        perPage: 1,
      },
    },
  },
};
